module.exports = __webpack_public_path__ + "static/media/dog-8.395cac5a.jpg";